import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { nomeModulo } from '../utils/modulosLicenca';

export default function ModuloBloqueado({ modulo, titulo }) {
  const nome = titulo || (modulo ? nomeModulo(modulo) : 'Recurso');

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6, px: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }}>
        <LockOutlinedIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          {nome} não habilitado
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Este recurso não faz parte da sua licença atual. Entre em contato com sua revenda
          para contratar o módulo{modulo ? ` ${modulo}` : ''}.
        </Typography>
        <Button component={RouterLink} to="/dashboard" variant="contained">
          Voltar ao início
        </Button>
      </Paper>
    </Box>
  );
}
